import { notification, Select, Spin } from "antd";
import request from "helper/request";
import React, { useState } from "react";
import "./DriverRegisterPage.scss";
import {
  InputPasswordHook,
  InputHook,
  PhoneInputHook,
  CheckBoxHook
} from "components/hook-forms";
import Cards from "modules/client/drivers/components/Cards";
import { Button } from "antd";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { registerForm } from "modules/client/drivers/forms/drivers/schema";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import { VEHICLE_TYPE_OPTIONS } from "configs/constants";

const DriverRegister = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [vehicleCategoryOnRegistrationList, setVehicleCategoryOnRegistrationList] =
    useState(VEHICLE_TYPE_OPTIONS);
  const [vehicleTypeOnRegistration, setVehicleTypeOnRegistration] =
    useState(VEHICLE_TYPE_OPTIONS);

  const handleSubmitForm = async (values) => {
    setIsLoading(true);
    try {
      await request.post("/drivers/register", { ...values, vehicleTypeOnRegistration });
      window.location.href = "/drivers/register/success";
    } catch (e) {
      setIsLoading(false);
      notification.error({
        message: JSON.parse(e?.message)?.message
      });
    }
  };

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: "onSubmit",
    resolver: yupResolver(registerForm)
  });

  const vehicleTypeOnChange = (value) => {
    setVehicleTypeOnRegistration(value);
  };

  return (
    <Spin spinning={isLoading}>
      <div className="driver-register-page">
        <div className="background-section" />
        <div className="main-content-page">
          <div className="wrap-logo">
            <img src={`/logos/user/${window.REACT_APP_LOGO_FILE_NAME}`} />
          </div>
          <div className="wrap-form-content" style={{ marginTop: "20px" }}>
            <div className="wrap-steps">
              <div className="title" style={{ marginBottom: 0 }}>
                Drivers Registration
              </div>
            </div>
            <div className="wrap-form">
              <form
                onSubmit={handleSubmit(handleSubmitForm)}
                style={{ border: "solid 2px white" }}
              >
                <Cards rightTitle="All fields are required">
                  <div className="wrap-step-1-form">
                    <InputHook
                      control={control}
                      label="First Name"
                      placeholder="First Name"
                      name="firstName"
                      showOptionsName={false}
                      errors={errors}
                    />
                    <InputHook
                      control={control}
                      label="Last Name"
                      placeholder="Last Name"
                      name="lastName"
                      showOptionsName={false}
                      errors={errors}
                    />
                    <InputHook
                      control={control}
                      label="Email"
                      placeholder="Email"
                      name="email"
                      showOptionsName={false}
                      errors={errors}
                    />
                    <PhoneInputHook
                      control={control}
                      label="Phone Number"
                      placeholder="Phone Number"
                      name="phone"
                      showOptionsName={false}
                      errors={errors}
                      required={true}
                    />
                    <InputPasswordHook
                      control={control}
                      label="Password"
                      placeholder="Password"
                      name="password"
                      showOptionsName={false}
                      errors={errors}
                    />
                    <InputPasswordHook
                      control={control}
                      label="Confirm Password"
                      placeholder="Confirm Password"
                      name="confirmPassword"
                      showOptionsName={false}
                      errors={errors}
                    />
                    <div>
                      <label style={{ fontSize: 16 }}>
                        Which vehicle(s) do you plan to use?
                      </label>
                    </div>
                    <Select
                      size="large"
                      placeholder="Select a vehicle type"
                      mode="multiple"
                      name="vehicleTypeOnRegistration"
                      onChange={vehicleTypeOnChange}
                    >
                      {vehicleCategoryOnRegistrationList.map((vehicleType, index) => (
                        <Select.Option key={index + 1} value={vehicleType}>
                          {vehicleType}
                        </Select.Option>
                      ))}
                    </Select>

                    <CheckBoxHook
                      showOptionsName={false}
                      control={control}
                      name="agree"
                      errors={errors}
                      classNameCheckbox="secondary"
                      showLabel={false}
                      className="agree-checkbox"
                    >
                      <div>
                        <span>I agree with Flexio &nbsp;</span>
                        <Link
                          to={{
                            pathname: isMobile
                              ? "https://www.goflexio.com/driverterms_eng"
                              : "https://www.goflexio.com/clientterms"
                          }}
                          target="_blank"
                        >
                          <span className="link">Terms & Conditions</span>
                        </Link>
                      </div>
                    </CheckBoxHook>
                    <Button type="primary" htmlType="submit" style={{ marginTop: 8 }}>
                      Complete Registration
                    </Button>
                  </div>
                  <div
                    className=""
                    style={{
                      width: "100%",
                      textAlign: "center",
                      marginTop: "-20px",
                      padding: "20px"
                    }}
                  >
                    <p className="text-center text-gray-300">
                      {"Already have an account?"} <Link to="/driver/login">LogIn</Link>
                    </p>
                  </div>
                </Cards>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};
export default DriverRegister;
